// @greenlight-spec: 32-knowledge.md
// @greenlight-spec: 28-it-dashboard-ui.md
import type { KnowledgeScope } from '@greenlight/contract';

// RBAC for direct edits and for proposal reviews, per 32-knowledge.md §Editorial
// model and RBAC + §Proposal flow. The two surfaces share the same per-scope
// rule set at MVP (org/integration = org_admin; app = owner/co-owner + IT roles),
// so a single predicate covers both. If the spec splits them later, wrap callers
// separately rather than overload this function.
export function canMutateScope(role: string | undefined, scope: KnowledgeScope): boolean {
  if (!role) return false;
  if (scope === 'app') return role === 'org_admin' || role === 'admin' || role === 'user';
  return role === 'org_admin';
}

export function formatKnowledgeDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
